/**
 * choice-grid.v1 cizici — cok maddeli seclmeli izgara (her madde ayri tekil secim).
 *
 * Kullanim: bir sayfada N kucuk soru; her maddede stem (cumle basi) + birkac sik.
 * Cocuk her madde icin BIR sik secer. Sunucudaki dogru sik istemciye GELMEZ
 * (isCorrect strip edilir). Cevap her madde secilene kadar null (ileri kapali).
 *
 * Icerik: { prompt?, items:[{id,text,options:[{id,text}]}] }
 * Cevap:  onAnswerChange({ selections:{ <itemId>:<optionId> } })
 */
import { useEffect, useRef, useState } from "react";
import type { MechanicProps } from "./types";

interface GOption {
  id: string;
  text: string;
}
interface GItem {
  id: string;
  text: string;
  options: GOption[];
}
interface GContent {
  prompt?: { text?: string };
  items?: GItem[];
}

export function ChoiceGridItem({ item, onAnswerChange }: MechanicProps) {
  const c = item.content as unknown as GContent;
  const items = c.items ?? [];
  const saved = item.answer?.selections as Record<string, string> | undefined;
  const [sel, setSel] = useState<Record<string, string>>(saved ?? {});

  const cb = useRef(onAnswerChange);
  cb.current = onAnswerChange;
  useEffect(() => {
    const done = items.length > 0 && items.every((it) => sel[it.id]);
    cb.current(done ? { selections: sel } : null, Object.keys(sel).length > 0 ? { selections: sel } : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sel]);

  return (
    <div className="mech grid-mech">
      {c.prompt?.text && <h2 className="prompt">{c.prompt.text}</h2>}
      <div className={`grid-list${items.length > 6 ? " two-col" : ""}`}>
        {items.map((it, i) => (
          <div className="grid-item" key={it.id}>
            <div className="grid-stem">
              <span className="grid-no">{i + 1}.</span> {it.text}
            </div>
            <div className="grid-opts">
              {(it.options ?? []).map((o) => {
                const on = sel[it.id] === o.id;
                return (
                  <button
                    type="button"
                    key={o.id}
                    className={`grid-chip${on ? " on" : ""}`}
                    onClick={() => setSel((p) => ({ ...p, [it.id]: o.id }))}
                    aria-pressed={on}
                  >
                    {o.text}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
